export default 'https://tme.understood.org/assets/mask_world_door.aef0c253.glb'